// extracted by mini-css-extract-plugin
module.exports = {"container":"LightboxPage_container__mT9Jc","header":"LightboxPage_header__xmMC5","back":"LightboxPage_back__1k6wV","content":"LightboxPage_content__kxa8e"};